function exigir(nome: string, valor: string | undefined): string {
  if (!valor || valor.length === 0) {
    if (import.meta.env.PROD) {
      throw new Error(`Variavel de ambiente obrigatoria nao definida: ${nome}`);
    }
    return "";
  }
  return valor;
}

export const env = {
  apiUrl: exigir("VITE_API_URL", import.meta.env["VITE_API_URL"]),
  publicAppUrl: import.meta.env["VITE_PUBLIC_APP_URL"] ?? "http://localhost:3001",
};
